import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  balance: 0,
  chargesPerDistributor: 0,
};

const balanceSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    setBalance: (state, action) => {
      state.balance = action.payload;
    },
    setChargesPerDistributor: (state, action) => {
      state.chargesPerDistributor = action.payload;
    },
  },
});

export const { setBalance, setChargesPerDistributor } = balanceSlice.actions;
export default balanceSlice.reducer;
